import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./quotation-initial";

const quotationSlice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    onLoading(state, action) {
      state.isLoading[action.payload] = true;
    },
    rejectedActions(state, action) {
      state.isLoading[action.payload.name] = false;
      state.error = action.payload;
    },
    loadedAllQuotations(state, action) {
      state.allQuotations = action.payload;
      state.isLoading.allQuotations = false;
    },
    loadedAllQuotationsExport(state, action) {
      state.allQuotationsExport = action.payload;
      state.isLoading.allQuotations = false;
    },
    loadedApprovalList(state, action) {
      const { approvalTemplates, approvalProgress } = action.payload;
      const sortedApprovalTemplates = approvalTemplates.sort(
        (a, b) => a.step_number - b.step_number
      );
      const progressList =
        (approvalProgress && approvalProgress.length > 0 && approvalProgress) ||
        [];

      // 1.) check current approval list compare with approval template
      // 2.) if they not have people in that particular template then use people form approval list instead
      // 3.) else if they still have approval and not deleted yet then use approval template as usual

      let formatApprovalList = [];
      sortedApprovalTemplates.forEach((approvalTemplate) => {
        if (approvalTemplate.is_required_approve) {
          const matchedProgress = progressList.find(
            (progress) => progress.step_number === approvalTemplate.step_number
          );
          const formatApprovalWithStatus = {
            id: approvalTemplate.id,
            step_number: approvalTemplate.step_number,
            reviewer_list: approvalTemplate.reviewer_list,
            approval_status:
              (matchedProgress && matchedProgress.approval_status) || null,
            created_date:
              (matchedProgress && matchedProgress.created_date) || null,
            approved_by:
              (matchedProgress &&
                approvalTemplate.reviewer_list.find(
                  (approve) =>
                    approve.document_id ===
                    matchedProgress.approved_by_document_id
                )) ||
              (matchedProgress && matchedProgress.approved_by) ||
              null,
            is_required_approve: approvalTemplate.is_required_approve,
          };
          formatApprovalList.push(formatApprovalWithStatus);
        }
      });

      state.approvalList = formatApprovalList;
    },
    loadedQuotation(state, action) {
      state.quotation = action.payload;
      state.isLoading.quotation = false;
    },
    loadedQuotationPriceList(state, action) {
      state.quotationPriceList = action.payload.quotation;
      state.orderPriceList = action.payload.order;
      state.isLoading.quotationPriceList = false;
    },
    loadedSalesOrderTab(state, action) {
      state.salesOrderTab = action.payload;
      state.isLoading.quotation = false;
    },
    updateQuotationStatus(state, action) {
      state.quotation.render_status = action.payload;
      state.isLoading.quotation = false;
    },
    updateQuotationIsLate(state, action) {
      state.quotation.is_late = action.payload;
    },
    updateApprovalStatus(state, action) {
      const { approval_list, user } = action.payload;

      const sortedApprovalProgress = approval_list.sort(
        (a, b) => a.created_date - b.created_date
      );

      const findApprover =
        sortedApprovalProgress &&
        sortedApprovalProgress.length > 0 &&
        sortedApprovalProgress?.map((approval) => {
          return {
            approval_status: approval?.approval_status,
            reviewer_document_id_list:
              approval?.approval_template &&
              approval?.approval_template?.reviewer_document_id_list,
            reviewer_list:
              approval?.approval_template &&
              approval?.approval_template?.reviewer_list,
            created_date: approval?.created_date,
          };
        });

      const isHaveApproval = sortedApprovalProgress?.every(
        (approval) =>
          approval?.approval_template &&
          approval?.approval_template?.is_required_approve === true
      );

      const formatApprovalList =
        findApprover &&
        findApprover.filter((approval) => approval.reviewer_list !== null);

      const foundWaitApprove =
        formatApprovalList &&
        formatApprovalList.find(
          (approval) => approval.approval_status === "PENDING"
        );

      const isHaveApprovalPermission =
        foundWaitApprove &&
        foundWaitApprove?.reviewer_document_id_list?.includes(user.document_id);

      state.isHaveApprovalPermission = isHaveApprovalPermission;
      state.isHaveApproval = isHaveApproval;

      // 1.) check current approval list compare with approval template
      // 2.) if they not have people in that particular template then use people form approval list instead
      // 3.) else if they still have approval and not deleted yet then use approval template as usual

      if (formatApprovalList && formatApprovalList.length > 0) {
        formatApprovalList.forEach((approval, index) => {
          if (state.approvalList[index]) {
            state.approvalList[index].approval_status =
              approval.approval_status;
          }
        });
      }
    },
    resetAllQuotations(state) {
      state.allQuotations = initialState.allQuotations;
      state.error = initialState.error;
    },
    resetAllQuotationsExport(state) {
      state.allQuotationsExport = initialState.allQuotationsExport;
      state.error = initialState.error;
    },
    resetQuotation(state) {
      state.quotation = initialState.quotation;
      state.salesOrderTab = initialState.salesOrderTab;
      state.error = initialState.error;
    },
    resetQuotationError(state) {
      state.error = initialState.error;
    },
    resetQuotationPriceList(state) {
      state.quotationPriceList = initialState.quotationPriceList;
      state.orderPriceList = initialState.orderPriceList;
    },
  },
});

export const quotationActions = quotationSlice.actions;

export default quotationSlice.reducer;
